export default [
    [
        '👋',
        'Greetings and farewells',
        ['👋','🖐','🛏','🧧','🌅','🤚']
    ],
    [
        '😊',
        //'🤏' 약간 태그 보류
        'Emotions',
        ['😊','😆','😍','☺','💆','😲','😅','😒','😡','😞','😢','🙇','😱','😐','🤤','😪','😴','👍','🤣','😜','😉','🤨','😑','🤔','😩','🙃','😣','😶','😀','🤗','🤩','😏','😋','🤪','😰','🥴','🥺','😤','😵','🙄','😎','🤦','🤷','☠','👎','💪','🕴','😌','💔']
    ],
    [
        '💬',
        'Situations',
        ['🥵','🥶','😴','🚿','🍻','📖','🥳','😶','🤗','🥴','👊','👀','📸','🚶','🏃','🙋','💥','🌧','🌩','👭','🧖','☠','🤝','💸','🍀','💇','🤳','💨','🌃','💬','🛑','⏱','📢','💯','🗯','💪','💄','🌇','🌨','🎃','🛀','⚠','🏳','🆘','💼','✌','🤙','😷','📞','🚽','🙈','🎂', '😘', '🤫', '🙇','🤤','😪','🤒','👌','🙌','😜','😉','🧎','🤨','🤔','😣','😋','🤑','🤥','🤕','🤮','🤯','🤓','🧐','😵','❌','🙏','✨','❓','💑','🕴','🤬','👏']
    ],
    [
        '⚽',
        'Activity',
        ['🤼','🎮','💃','🏋','🏀','🏆','🏊','🎟','🏌','🎵','🎤','🎷','♨','🛹','⚽','⚾','🎳','🥊','🎧','🎸','🎹','🥁','🎣','🧘','⛸','🏂','🚴','🛷','👭','🧖','🤳']
    ],
    [
        '👨‍⚕️',
        'People & Characters',
        ['🧟','👹','👽','🤖','👨‍⚕️','👨‍🍳','👨‍🔧','👨‍🏭','👨‍💼','👨‍💻','👨‍🎤','🎅','🦸','🦹','🧝','🧞','👶','👑','👻','😈', '😇','🎃']
    ],
    [
        '🐻',
        'Animals',
        ['🐟','🐭','🐵','🐶','🐱','🐅','🐷','🐰','🐣','🦐','🦊','🦁','🐧','🕊','🦟']
    ],
    [
        '🍔',
        'Food & Drinks',
        ['🍺','🍽','🥤','🍬','🧇','🍐','🍎','🍞','🍖','🍔','🥘','🍚','🍲','🍨','🦴','🍉','🍌','🍓','🥔','🥕','🍕','🍳','🍿','🍣','🍫','🍯','☕','🍷','🥄','🧀','🍸','🍹','🍰','🍩','🍪','🍇','🍋','🍍','🥭','🥖','🍟','🌭','🥪','🌮','🌯','🍝','🍦','🍗','🍵']
    ],
    [
        '💡',
        'Objects',
        ['💵','📕','🏍','🍃','🌺','🌲','🚇','🚌','🚕','🚗','🧳','🌕','☀','⭐','☃','🧸','💩','💌','💦','🕳','💣','💐','🌸','🌹','🕛','⏰','🌈','🔥','🌊','🎄','🎈','🎁','👓','🕶','🛍','📱','🔋','📷','💡','💳','📦','✏','🔫','💊','🚪','🛋','🧻','🧽','🛒','🏴‍☠️','💻','🍁','☂','🌼', '❤', '💔', '🍀', '💄', '🏳','🚽','🏆','🥄']
    ],
    [
        '🏖',
        'Travel & Places',
        ['🏖','🏕','🎆','⛰','🏥','🏬','🚉','♨', '🧳']
    ]
  ];